import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Badge, Box, HStack, Text, VStack } from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";
import { ChatTitle } from "../logics/chatLogic";
import { formatTimeStampToDay } from "../logics/timeLogic";
import { setLsCurrentChat } from "../logics/chatLogic";

// Helper function to truncate message to 50 characters
const truncateMessage = (message, maxLength = 50) => {
  if (!message || message.length <= maxLength) {
    return message;
  }
  return message.substring(0, 47) + "...";
};

const ChatListItem = ({ chat }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const chatTitle = ChatTitle(chat, currentUser);

  const navigateToConvoPage = (chat) => {
    setLsCurrentChat(chat);
    navigate(`/chats/${chat._id}/messages`);
  };

  return (
    <HStack
      key={chat._id}
      w="100%"
      p={4}
      bg="white"
      _hover={{ bg: "gray.50", cursor: "pointer" }}
      _active={{ bg: "gray.100" }}
      onClick={() => navigateToConvoPage(chat)}
      spacing={3}
      align="flex-start"
    >
      <Avatar name={chatTitle} size="md" fontSize="sm" fontWeight="600" />
      <VStack align="start" spacing={1} w="100%" flex="1">
        <HStack w="100%" justify="space-between" align="center">
          <Text
            fontWeight="600"
            fontSize="md"
            color="gray.800"
            isTruncated
            flex="1"
          >
            {chatTitle}
          </Text>
          <Text fontSize="xs" color="gray.400" fontWeight="500">
            {chat.lastMessage
              ? formatTimeStampToDay(chat.lastMessage.createdAt)
              : formatTimeStampToDay(chat.createdAt)}
          </Text>
        </HStack>
        <HStack w="100%" justify="space-between" align="center">
          <Box flex="1">
            {chat.lastMessage ? (
              chat.typing ? (
                <Text fontSize="sm" fontWeight="500" color="teal.500">
                  Typing...
                </Text>
              ) : (
                <Text fontSize="sm" color="gray.600" lineHeight="1.3">
                  {chat.lastMessage.sender._id === currentUser.id
                    ? "You: "
                    : ""}
                  {truncateMessage(chat.lastMessage.message)}
                </Text>
              )
            ) : (
              <Text fontSize="sm" color="gray.400" fontStyle="italic">
                Click to start conversation
              </Text>
            )}
          </Box>
          {chat.unreadCount > 0 && (
            <Badge
              colorScheme="teal"
              variant="solid"
              borderRadius="full"
              px={2}
              py={1}
              fontSize="xs"
              fontWeight="600"
            >
              {chat.unreadCount > 99 ? "99+" : chat.unreadCount}
            </Badge>
          )}
        </HStack>
      </VStack>
    </HStack>
  );
};
export default ChatListItem;
